import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/user/operator`

export default {
  options(payload) {
    return Client.get(`${resource}/option-all`, {
      params: payload,
    })
  },
}
